import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { styledHeaderText } from "../../styled";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: {
        text: styledHeaderText(t("newLayerFromTable.dialogHeader", { ns: "dialogs" })),
        icon: "layers",
      },
      meta: {
        aliasLabel: t("newLayerFromTable.layerName", { ns: "dialogs" }),
        descriptionLabel: t("newLayerFromTable.layerDescription", { ns: "dialogs" }),
        loaderLabel: t("newLayerFromTable.uploadImage", { ns: "dialogs" }),
      },
      applyText: t("actions.create", { ns: "common" }),
      attributes: {
        label: t("newLayerFromTable.attributes", { ns: "dialogs" }),
        description: t("newLayerFromTable.attributes", { ns: "dialogs" }),
        icon: "table",
      },
    }),
    [t],
  );
};
